import { UserIcon as PhosphorUserIcon } from "@phosphor-icons/react/dist/ssr/User";

import { createAppIcon } from "@/components/createAppIcon";

export const PersonIcon = /* @__PURE__ */ createAppIcon(PhosphorUserIcon);
